import { Box, Typography, CircularProgress } from '@mui/material';
import useSecureImage from '../../hooks/useSecureImage';

const SecureImage = ({ url, alt, sx }) => {
    const { imgSrc, loading, error } = useSecureImage(url);

    if (loading) {
        return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 50, height: 50 }}><CircularProgress size={20} /></Box>;
    }

    if (error || !imgSrc) {
        return <Typography variant="caption" color="error">Failed to load image</Typography>;
    }

    return <Box component="img" src={imgSrc} alt={alt} sx={sx} />;
};

export default SecureImage;
